module.exports = __webpack_public_path__ + "media/images/expe-500df41d5ab90f26d867c9a5ecec5c41.svg";